import { ReactElement } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FAR_LINK } from 'const/icons'
import i18n from 'strings/i18n'
import { Small } from 'syf-component-library/ui/typography'

import {
  AccountEndingInWrapper,
  AccountLinkButton,
  AccountLinkText,
  CardName
} from './subcomponents'

interface CardBankDetailsProps {
  accountLast4: string
  cardName: string
  className?: string
  isFullPage?: boolean
  handleOnClick: () => void
  isLinkDisabled: boolean
  isSetpayAccountOrPayLater: boolean
}

const CardBankDetails = ({
  accountLast4,
  cardName,
  className,
  handleOnClick,
  isFullPage,
  isLinkDisabled,
  isSetpayAccountOrPayLater
}: CardBankDetailsProps): ReactElement => {
  const label = i18n({
    labels: isSetpayAccountOrPayLater ? 'loanEndingIn' : 'accountEndingIn'
  })

  return (
    <div className={className} data-test="card-bank-details">
      <CardName weight="bold" $isFullPage={isFullPage}>
        {cardName}
      </CardName>
      {isLinkDisabled ? (
        <Small>{`${label} ${accountLast4}`}</Small>
      ) : (
        <AccountLinkButton
          buttonType="text"
          data-analytics="clicktrackingevent"
          dataCy="account-link-button"
          data-object="link"
          data-reason="legacy account link"
          data-test="account-link-button"
          data-type="legacy account link"
          onClick={handleOnClick}
        >
          <AccountLinkText weight="bold" isInline>
            <FontAwesomeIcon icon={FAR_LINK} />
            &nbsp;
            <AccountEndingInWrapper>{label}</AccountEndingInWrapper>
            {` ${accountLast4}`}
          </AccountLinkText>
        </AccountLinkButton>
      )}
    </div>
  )
}

export default CardBankDetails
